class PopupRestriction {
  constructor(elementSelector) {
    this.element = document.querySelector(elementSelector);
    if (!this.element) {
      return;
    }
    let cookieAvailable = document.cookie.includes(
      "remember_popup_restriction="
    );
    if (!cookieAvailable) {
      this.activatePopup();
    }
  }

  static init() {
    new PopupRestriction(".popup");
  }

  activatePopup() {
    document.body.classList.add("popup-restriction");
    this.popupAction();
  }

  popupAction() {
    const successButton = this.element.querySelector(".popup__button-success");
    const failedButton = this.element.querySelector(".popup__button-failed");
    if (!successButton || !failedButton) {
      return;
    }

    let rememberCheckbox = this.element.querySelector("#remember_cookie");

    successButton.addEventListener("click", () => {
      this.element.classList.remove("restricted");
      let expiredTime = new Date();
      if (rememberCheckbox.checked) {
        let expirateDate = rememberCheckbox.getAttribute("data-expires");
        expiredTime.setDate(expiredTime.getDate() + parseInt(expirateDate));
      } else {
        expiredTime.setDate(expiredTime.getDate() + 1);
        // document.cookie = `remember_popup_restriction=success;expires=session`;
      }
      document.cookie = `remember_popup_restriction=success;expires=${expiredTime.toUTCString()}`;

      document.body.classList.remove("popup-restriction");
    });

    failedButton.addEventListener("click", () => {
      this.element.classList.add("restricted");
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (!Shopify.designMode) {
    PopupRestriction.init();
  }
});
